module.exports = __webpack_public_path__ + "img/conasi365_logo.c61e538f.png";